import {
  DashboardMembershipsListDocument,
  type DashboardMembershipsListQuery,
  type DashboardMembershipsListQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

export const DASHBOARD_MEMBERSHIPS_LIST_LOADER = async () => {
  const { data } = await client.query<
    DashboardMembershipsListQuery,
    DashboardMembershipsListQueryVariables
  >({
    query: DashboardMembershipsListDocument,
    fetchPolicy: "network-only",
  });

  return data;
};
